import { Stack, Text, Box } from '@ltvco/refresh-lib/theme';

import { ChipData } from 'components/ChatBV/types';

import { ChatChipsCircleIcon, ChatChipsContainer } from './components';

interface ChatChipsProps {
  chips?: ChipData[];
  onChipClick?: (chipTitle: string) => void;
  // Opt-in light-blue hover (DeepSearch); ChatBV omits it.
  lightBlueHover?: boolean;
}

export const ChatChips = ({
  chips = [],
  onChipClick,
  lightBlueHover,
}: ChatChipsProps) => {
  return (
    <Stack
      direction="row"
      gap={1}
      flexWrap="wrap"
      justifyContent="center"
      sx={{
        '& > *': {
          flex: '0 0 auto',
        },
      }}
    >
      {chips.map((chip, index) => (
        <ChatChipsContainer
          key={index}
          lightBlueHover={lightBlueHover}
          onClick={() => onChipClick?.(chip.type)}
          sx={{ cursor: onChipClick ? 'pointer' : 'default' }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <ChatChipsCircleIcon>{chip.icon}</ChatChipsCircleIcon>
            <Text variant="body2" fontWeight="medium">
              {chip.title}
            </Text>
          </Box>
        </ChatChipsContainer>
      ))}
    </Stack>
  );
};
